import { type FileCategoryBase } from "src/cases/caseView/FileCategory";
import {
  CreateCaseContextStep,
  SourceOption,
} from "src/cases/createCase/CreateCaseContextStep";
import { CreateCasePropertiesStep } from "src/cases/createCase/CreateCasePropertiesStep";
import { CreateCaseRoutingStep } from "src/cases/createCase/CreateCaseRoutingStep";
import {
  CreateCaseStep,
  useCurrentCreateCaseStep,
} from "src/cases/createCase/createCaseSteps";
import { CasePropertiesValue } from "src/clients/case-management";

type CreateCaseFormRouterProps = {
  sourceOptions: SourceOption[] | undefined;
  fileCategories: FileCategoryBase[];
  caseProperties: Record<string, CasePropertiesValue> | undefined;
  statusProperty: CasePropertiesValue | undefined;
  queueId: string;
  steps: CreateCaseStep[];
};

export const CreateCaseFormRouter: React.FC<CreateCaseFormRouterProps> = ({
  sourceOptions,
  fileCategories,
  caseProperties,
  statusProperty,
  queueId,
  steps,
}) => {
  const [currentStep] = useCurrentCreateCaseStep(steps);

  switch (currentStep.id) {
    case "context":
      return (
        <CreateCaseContextStep
          fileCategories={fileCategories}
          sourceOptions={sourceOptions}
          step={currentStep}
        />
      );
    case "properties":
      return (
        <CreateCasePropertiesStep
          caseProperties={caseProperties}
          step={currentStep}
        />
      );
    case "case-routing":
      return (
        <CreateCaseRoutingStep
          queueId={queueId}
          statusProperty={statusProperty}
          step={currentStep}
        />
      );
  }
};
